import React from 'react';


class BackgroundImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      image: undefined
    };

    this.onImageLoad = this.onImageLoad.bind(this);
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(previousProps) {
    if (previousProps.image != this.props.image) {
      this.loadImage();
    }
  }

  clearImage() {
    this.setState({
      loaded: false,
      image: undefined
    });
  }

  loadImage() {
    this.clearImage();

    var image = this.props.image;

    if (image) {
      var preloadImage = new Image();
      preloadImage.onload = this.onImageLoad;
      preloadImage.src = image;
    }
  }

  onImageLoad() {
    this.setState({
      loaded: true,
      image: this.props.image
    });
  }

  render() {
    var classNames = ['sbm-background-image'];
    var style = {};
    let overlayimage;
    if (this.props.variant) {
      classNames.push('sbm-background-image--' + this.props.variant);
    }

    if (this.props.contain) {
      classNames.push('sbm-background-image--contain');
    }

    if (this.state.loaded) {
      classNames.push('is-loaded');
    }

    if (this.state.image) {
      style.backgroundImage = 'url("' + this.state.image + '")';
    }

    if (this.props.overlayimage) {
      overlayimage = <div className="overlay">
          <i className="fa fa-play-circle-o"></i>
        </div>
    }

    return (
      <div className={classNames.join(' ')}>
        <div
          className="sbm-background-image__image"
          style={style}
        />
        
        {overlayimage}

      </div>
    );
  }
}

export default BackgroundImage;

